import React from 'react';
import {
  getFieldsByCategory,
  PassFieldDefinition,
  PassTypeDefinition,
} from '../../Companies/Passes/passFieldConfig';
import {
  getExpirationLabel,
  getExpirationStatus,
} from '../../../utils/passExpirationUtils';

type PassState = {
  enabled: boolean;
  values: Record<string, string>;
};

type Props = {
  tab: PassTypeDefinition;
  state: PassState;
  onToggle: (enabled: boolean) => void;
  onFieldChange: (key: string, value: string) => void;
  readOnly?: boolean;
};

const DriverPassFieldsPanel: React.FC<Props> = ({
  tab,
  state,
  onToggle,
  onFieldChange,
  readOnly = false,
}) => {
  const renderField = (field: PassFieldDefinition) => {
    const inputId = `pass-${tab.id}-${field.key}`;
    const value = state.values[field.key] ?? '';
    const expirationStatus = getExpirationStatus(value);
    const hasValue = Boolean(value.trim());

    return (
      <div
        key={field.key}
        className={`ed-driver__pass-row ed-driver__pass-row--${expirationStatus}${
          field.colSpan === 2 ? ' ed-driver__pass-row--wide' : ''
        }${hasValue ? ' is-filled' : ''}`}
      >
        <label className="ed-driver__pass-row-label" htmlFor={inputId}>
          {field.label}
        </label>
        <input
          id={inputId}
          type="date"
          className="ed-driver__pass-row-input"
          value={value}
          onChange={(e) => onFieldChange(field.key, e.target.value)}
          disabled={readOnly || !state.enabled}
          title={hasValue ? `Vence: ${value}` : 'Sin fecha registrada'}
        />
        {hasValue && (
          <span
            className={`ed-driver__pass-row-badge ed-driver__pass-row-badge--${expirationStatus}`}
          >
            {getExpirationLabel(expirationStatus)}
          </span>
        )}
      </div>
    );
  };

  const renderSection = (title: string, fields: PassFieldDefinition[]) => (
    <section className="ed-driver__pass-section" aria-label={title}>
      <h3 className="ed-driver__pass-section-title">{title}</h3>
      <div className="ed-driver__pass-rows">{fields.map(renderField)}</div>
    </section>
  );

  return (
    <div className="ed-driver__pass-detail">
      <div className="ed-driver__pass-toolbar">
        <p className="ed-driver__pass-description">{tab.description}</p>
        <div className="ed-driver__pass-status">
          <span className="ed-driver__pass-status-label">Estado</span>
          <button
            type="button"
            className={`ed-driver__switch${state.enabled ? ' is-on' : ''}`}
            onClick={() => onToggle(!state.enabled)}
            aria-pressed={state.enabled}
            aria-label={`${tab.label}: ${state.enabled ? 'activo' : 'inactivo'}`}
            disabled={readOnly}
          >
            <span className="ed-driver__switch-track" aria-hidden>
              <span className="ed-driver__switch-thumb" />
            </span>
            <span className="ed-driver__switch-text">
              {state.enabled ? 'Activo' : 'Inactivo'}
            </span>
          </button>
        </div>
      </div>

      <div className="ed-driver__pass-sections">
        {renderSection('Pase', getFieldsByCategory(tab, 'PASE'))}
        {renderSection('Licencia', getFieldsByCategory(tab, 'LICENCIA'))}
      </div>
    </div>
  );
};

export default DriverPassFieldsPanel;
